import React, { useImperativeHandle, forwardRef, useState } from 'react'
import PropTypes from 'prop-types'
import Lightbox from 'react-image-lightbox'
const ImgLightBox = forwardRef(({ gallery }, ref) => {
  const [isOpen, setIsOpen] = useState(false)
  // const [gallery, setGallery] = useState([])
  const [index, setIndex] = useState(0)
  useImperativeHandle(ref, () => ({
    openLightBox: (startIndex) => {
      setIsOpen(true)
      setIndex(startIndex || 0)
    },
  }))
  const nextImage = () => {
    setIndex((index + 1) % gallery.length)
  }
  const prevImage = () => {
    setIndex((index + gallery.length - 1) % gallery.length)
  }
  const closeLightBox = () => {
    setIsOpen(false)
  }

  return (
    <>
      {isOpen && (
        <Lightbox
          mainSrc={gallery[index]}
          nextSrc={gallery[(index + 1) % gallery.length]}
          prevSrc={gallery[(index + gallery.length - 1) % gallery.length]}
          onCloseRequest={closeLightBox}
          onMovePrevRequest={prevImage}
          onMoveNextRequest={nextImage}
        />
      )}
    </>
  )
})
ImgLightBox.propTypes = {
  gallery: PropTypes.array.isRequired,
}
export default ImgLightBox
